<template>
  <b-container fluid>
    <b-row
      v-if="!associatedImages || !associatedImages.length"
      class="empty-pictures"
    >
      <b-col class="text-center mt-3">
        <div
          style="opacity: .5"
          class="m-3"
        >
          <i
            class="fal fa-image fa-3x"
            aria-hidden="true"
          />
        </div>
        <div>
          <span class="is-italic">{{ $t('global.description.pictureEmptyTitle') }}</span>
        </div>
        <template v-if="!hideAttachOperations">
          <div class="mt-3">
            <p>{{ $t('global.description.pictureEmptyDiagnosisSubtitle') }}</p>
          </div>
          <div class="mt-4">
            <b-button
              class="btn__outline"
              :disabled="disabled"
              @click="$emit('showAssociatedImagesModal')"
            >
              {{ $t('global.description.associatePictures') }}
            </b-button>
          </div>
        </template>
      </b-col>
    </b-row>
    <div v-else>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between align-items-center">
            <span class="ap-title ap-title__section">{{ associatedImages.length }} {{ $tc('global.description.picture', associatedImages.length) }}</span>
            <b-button
              v-if="!hideAttachOperations"
              class="btn__icon btn__icon--primary  pr-0"
              style="margin-right: 0 !important"
              :disabled="disabled"
              @click="$emit('showAssociatedImagesModal')"
            >
              <i
                v-tooltip="$t('global.description.addPicture')"
                class="far fa-plus"
                aria-hidden="true"
              />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12">
          <div class="horizontal-divider my-2" />
        </b-col>
      </b-row>
      <b-row>
        <div class="picture-scroll w-100">
          <b-col cols="12">
            <b-card
              v-for="(image, index) in associatedImages"
              :key="index"
              img-top
              class="picture-card component-bg--hover mb-2"
            >
              <b-button
                v-if="!hideAttachOperations"
                class="float-btn"
                :disabled="disabled"
              >
                <i
                  class="far fa-times"
                  aria-hidden="true"
                  @click="onDeleteAttachment(image)"
                />
              </b-button>
              <div class="picture-zone">
                <img
                  :src="getThumbnailImage(image)"
                  class="card-img-top"
                  alt="thumbnail"
                  aria-hidden="true"
                >
              </div>
              <b-card-text>
                <div class="m-2 picture-text">
                  <div>
                    <span class="main">{{ image.attachment.filename }}</span>
                  </div>
                </div>
              </b-card-text>
            </b-card>
          </b-col>
        </div>
      </b-row>
    </div>
  </b-container>
</template>

<script>

export default {
    name: 'AssociatedImagesSidePanel',
    props: {
        associatedImages: { type: Array },
        disabled: { type: Boolean, required: false, default: false },
        hideAttachOperations: { type: Boolean, required: false, default: false }
    },
    methods: {
        async onDeleteAttachment(image) {
            const confirmed = await this.showConfirmationModalGlobal(this.$t('component.modalConfirmation.content'))
            if (confirmed) {
                this.$emit('deleteAttachment', image)
            }
        },
        getThumbnailImage(image) {
            return `data:${image.attachment.mimetype};base64, ${image.attachment.thumbnailBytes}`
        }
    }
}
</script>
